import { FC } from 'react';
import { Select } from 'antd';
import { Direction, getEnumOptions } from 'src/utils/enums';
import Arrow from '@svg/chevron-down_20.svg?react';

interface DirectionSelectProps {
  value: string;
  onChange: (value: string) => void;
}

const DirectionSelect: FC<DirectionSelectProps> = ({ value, onChange }) => (
  <Select
    value={value}
    onChange={onChange}
    className="select-direction"
    suffixIcon={<Arrow />}
    options={getEnumOptions(Direction)}
  />
);

export default DirectionSelect;
